import InvitePage from "./InviteContainer";

export default InvitePage;
